import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 195.2 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #E2483D)",
      d: "M0 3a3 3 0 0 1 3-3h45.8l-6.222 6H3a3 3 0 0 1-3-3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, #FFD5D2)",
      d: "M54.868 0H97.6l-6.222 6H48.8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, #E9F2FF)",
      d: "M103.668 0H146.4l-6.222 6H97.6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, #1868DB)",
      d: "M152.037 0H192.2a3 3 0 1 1 0 6h-45.8z"
    }, null, -1)
  ]))]))
}
export default { render: render }